module.exports = __webpack_public_path__ + "img/logo-white.d80c7ba2.png";